import { css } from 'emotion'
import { Colors, MenuLink, Easings, XSmall } from './..'
import { Link } from '../typo';


// LOGO
export const LogoStyle = css({
  padding: '0px 1.25rem',
  maxWidth: '200px',
  flexBasis: '200px',
  'svg': {
    verticalAlign: 'middle',
  },
  'a': {
    color: 'black',
    lineHeight: '1rem',
  },
  'span': {
    fontSize: '1rem',
    verticalAlign: 'middle',
    display: 'inline-block',
    '&:before': {
      content: '""',
      height: '1rem',
      width: 1,
      background: Colors.lightGrey,
      margin: '0px 0.75rem',
      display: 'inline-block',
      verticalAlign: 'middle',
    }
  },
})

//DEFAULT AFTER

const defaultAfterNav = {
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: 6,
    background: '#000',
    transition: `transform 200ms ${Easings.customEase}`,
    transform: 'scaleX(0)',
    transformOrigin: 'center left',
  }
}

const defaultLiStyle = {
  position: 'relative',
  padding: '0px 1.5rem',
  cursor: 'pointer',
  ...defaultAfterNav,
}

//NAV
export const NavStyle = css({
  maxWidth: 'calc(100% - 480px)',
  flexBasis: 'calc(100% - 480px)',
  'ul': {
    justifyContent: 'center',
  },
  'li': {
    ...defaultLiStyle,
    'svg': {
      transition: 'fill 400ms ease',
    },
    '&:hover': {
      'span' : {
        color: 'black',
        'svg': {
          fill: 'black',
        }
      }
    },
    '&.active:not(.disable)': {
      '&:after': {
        transform: 'scaleX(1)',
      },
      '&:not(.item-challenge) span' : {
        color: 'black',
        'svg': {
          fill: 'black',
        }
      }
    },
  },
  'a.main-nav--item': {
    ...defaultLiStyle,
    '&.in-view': {
      '&:after': {
        transform: 'scaleX(1)',
      },
      'span': {
        color: 'black',
        'svg': {
          fill: 'black',
        }
      }
    }
  },
  '.middle': {
    position: 'relative',
    display: 'inline-block',
    verticalAlign: 'middle',
    lineHeight: 1.2,
  },
  'span' : {
    ...MenuLink,
    color: Colors.mediumGrey,
    transition: 'color 200ms ease',
    'svg': {
      verticalAlign: 'middle',
      fill: Colors.mediumGrey,
    }
  },
  '.item-challenge': {
    '&:after': {
      background: Colors.red,
    },
    'span': {
      color: Colors.red,
    },
    // 'div': {
    //   transform: 'translateY(0.3rem)',
    // }
  },
  '.main-nav--desc': {
    display: 'block',
    ...XSmall
  }
})

//SECONDARY MENU

export const SecondaryNav = css({
  maxWidth: '280px',
  flexBasis: '280px',
  justifyContent: 'flex-end',
  '.profile-nav': {
    '@media (min-width: 1224px)': {
      maxWidth: 'calc(100% - 120px)',
      flexBasis: 'calc(100% - 120px)',
    }
  },
  '.btn': {
    display: 'block',
    position: 'relative',
    height: '80px',
    width: 60,
    border: 0,
    cursor: 'pointer',
    background: 'transparent',
    padding: 0,
    textAlign:'center',
    ...defaultAfterNav,
    'svg': {
      fill: Colors.mediumGrey,
      verticalAlign: 'middle',
      transition: 'fill 200ms ease',
    },
    '&:hover': {
      'svg': {
        fill: 'black',
      }
    },
    '&.notification-nav button':{
      '&.open': {
        '&:after': {
          transform: 'scaleX(1)',
        }
      }
    },
    '&.active': {
      'svg': {
        fill: 'black',
      },
      '&:after': {
        transform: 'scaleX(1)',
      }
    },
    '.dot': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      zIndex: 4,
      minWidth: 16,
      height: 16,
      lineHeight: '14px',
      fontSize: '0.6rem',
      color: 'white',
      border: '1px solid #FFF',
      transform: 'translate(4px, -10px)',
      background: Colors.red,
      borderRadius: 9999,
    },
  }
})

// MENU 
export const MobileNav = (open) => css({
  '.mobile-nav': {
    maxWidth: 'calc(1/4 * 100%)',
    flexBasis: 'calc(1/4 * 100%)',
  },
  '.btn': {
    display: 'block',
    position: 'relative',
    height: 60,
    width: '100%',
    border: 0,
    cursor: 'pointer',
    background: 'transparent',
    padding: 0,
    textAlign:'center',
    fill: Colors.mediumGrey,
    ...defaultAfterNav,
    '@media (min-width: 1024px)': {
      height: 80,
    },
    'svg': {
      verticalAlign: 'middle',
    },
    '.dot': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      zIndex: 0,
      minWidth: 16,
      height: 16,
      lineHeight: '14px',
      fontSize: '0.6rem',
      color: 'white',
      border: '1px solid #FFF',
      transform: 'translate(4px, -10px)',
      background: Colors.red,
      borderRadius: 9999,
    },
    '&.notification-nav button':{
      ...defaultAfterNav,
      '&.open': {
        '&:after': {
          transform: 'scaleX(1)',
        }
      }
    },
    '&.active:not(.disable)': {
      '&:after': {
        transform: 'scaleX(1)',
      }
    },
  },
  '.menu-nav': {
    ...defaultAfterNav,
    'span': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      height: 2,
      width: 18,
      background: Colors.mediumGrey,
      transform: 'translateX(-50%)',
      transition: `transform 0.4s ease`,
      transformOrigin: 'center left',
      '&:first-child':{
        transform: 'translateY(-50%) translateX(-50%) translateY(-4px)',
      },
      '&:last-child':{
        transform: 'translateY(-50%) translateX(-50%) translateY(6px) scaleX(0.6)',
        transformOrigin: 'center left',
      }
    }
  },
  '.menu-nav, .search-nav': {
    '&.active:after:not(.disable)': {
      transform: 'scaleX(1)',
    }
  }
}, open && {
  '.menu-nav': {
    '&:after':{
      transform: 'scaleX(1)'
    },
    'span': {
      '&:first-child':{
        transform: 'translateY(-50%) translateX(-50%) translateY(0px) rotate(-45deg)',
        transformOrigin: 'center center',
      },
      '&:nth-child(2)':{
        transform: 'translateX(-50%) scaleX(0.01)',
      },
      '&:last-child':{
        transform: 'translateY(-50%) translateX(-50%) translateY(0px) scaleX(1) rotate(45deg)',
        transformOrigin: 'center center',
      }
    }
  }
})

// MENU MOBILE 
export const MenuMobileStyle = (open, visible) => css({
  position: 'fixed',
  top: 60,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'white',
  zIndex: 0,
  padding: '2rem',
  transform: `translateX(${open ? 0 : 100}%)`,
  transformOrigin: 'center left',
  transition: 'transform 400ms ease',
  '.main-nav': {
    paddingLeft: 'calc(1/4 * 100%)',
    '& > li': {
      textTransform: 'uppercase',
      fontWeight: 800,
      lineHeight: 1.2,
      fontSize: '1.5rem',
      padding: '1rem 0',

      '&.item-challenge' : {
        color: Colors.red,
      },
      '.main-nav--desc': {
        display: 'block',
        fontSize: '0.8rem',
        fontWeight: 800
      }
    }
  },
  '.account-card': {
    width: '100%',
    position: 'inherit',
    '&--inner': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      padding: '0 2rem',
      transform: 'translateY(-100%) translateY(-2rem)',
    }
  },
  '.menu-mobile':{
    '&-head': {
      position: 'fixed',
      top: -60,
      left: 0,
      background: 'white',
      borderBottom: `1px solid ${Colors.lightGrey}`,
      width: '100%',
      height: 60,
      lineHeight: '60px',
      transform: `translateX(${visible ? 0 : 100}%)`,
      opacity: visible ? 1 : 0,
      transition: `all 300ms ${Easings.customEase}`,
      '@media (min-width: 1024px)': {
        height: 80,
        lineHeight: '80px',
      },
      '&-title': {
        fontSize: '1rem',
        textTransform: 'uppercase',
        fontWeight: 800,
        color: 'black',
        padding: '0 1rem',
        position: 'relative',
        ...defaultAfterNav,
        '&--challenge': {
          '&:after':{
            background: Colors.red,
          },
        },
        '&--inline': {
          color: Colors.red,
          display: 'inline-block',
          verticalAlign: 'middle',
          lineHeight: 1.2,
          'span': {
            fontSize: '0.7rem',
            display: 'block',
          },
        }
      },
      '&-title:after': {
        transform: 'scaleX(1)',
      }
    },
    '&-return': {
      width: 60,
      height: 60,
      transform: 'scaleX(-1)',
      textAlign: 'center',
      'svg': {
        fill: Colors.lightGrey,
        verticalAlign: 'middle',
      }
    },
    '&-close': {
      width: 60,
      height: 60,
      position: 'absolute',
      top: 0,
      right: 0,
      padding: 0,
      border: 0,
      background: 'none',
      'span': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: 16,
        height: 2,
        background: Colors.lightGrey,
        transformOrigin: 'center center',
        '&:first-child': {
          transform: 'translateX(-50%) translateY(-50%) rotate(-45deg)',
        },
        '&:last-child': {
          transform: 'translateX(-50%) translateY(-50%) rotate(45deg)',
        },
      }
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/partials/header.js